<template>
    <div>
        <div
            class="serial"
            :class="[
                { 'serial--mass': theme == 'mass' },
                { 'serial--prestige': theme == 'prestige' }
            ]"
        >
            <div class="serial__tabs">
                <div
                    class="serial__tab"
                    :class="{ 'serial__tab--active': serialType == 'QR_CODE' }"
                    @click="changeTab('QR_CODE')"
                >
                    <div class="serial__tab-label">
                        {{ lbl.gift_serial.qr_code }}
                    </div>
                </div>
                <div
                    class="serial__tab"
                    :class="{ 'serial__tab--active': serialType == 'CODE_128' }"
                    @click="changeTab('CODE_128')"
                >
                    <div class="serial__tab-label">
                        {{ lbl.gift_serial.barcode }}
                    </div>
                </div>
                <div
                    class="serial__tab"
                    :class="{ 'serial__tab--active': serialType == 'CODE' }"
                    @click="changeTab('CODE')"
                >
                    <div class="serial__tab-label">
                        {{ lbl.gift_serial.code }}
                    </div>
                </div>
            </div>
            <div class="serial__code-wrapper" v-if="isShowCode && isLoaded">
                <div
                    class="serial__instruction"
                    id="serial_show_code"
                >{{ serialHeader }}</div>

                <div
                    class="serial__code serial__code--text"
                    v-show="serialType == 'CODE'"
                >
                    <p
                        class="serial__code-value"
                        :class="{
                            'serial__code-value--long': serial.length > 12,
                            'serial__code-value--expired': serial == 'XXXXXXX'
                        }"
                    >
                        {{ serial }}
                    </p>
                    <div class="serial__copy-button">
                        <span
                            class="serial__copy-text"
                            v-clipboard:copy="serial"
                            v-clipboard:success="onCopyCode"
                            v-clipboard:error="onErrorCode"
                            >{{ lbl.gift_serial.copy_code }}</span
                        >
                        <img
                            src="@/assets/icon/ic-copy-code.svg"
                            alt="copy code"
                        />
                    </div>
                    <div class="serial__unavailable" v-if="!isAvailable">
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div class="serial__unavailable-text">
                                {{ reasonMsg }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="serial__code serial__code--barcode"
                    v-show="serialType == 'CODE_128'"
                >
                    <div class="serial__barcode">
                        <VueBarcode
                            class="serial__barcode-image"
                            :value="campaign.serial"
                            :options="barcodeConfig"
                        />
                    </div>
                    <div class="serial__unavailable" v-if="!isAvailable">
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div class="serial__unavailable-text">
                                {{ reasonMsg }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="serial__code serial__code--qrcode"
                    v-show="serialType == 'QR_CODE'"
                >
                    <div class="serial__qrcode">
                        <VueQrcode
                            :value="campaign.serial"
                            :options="qrcodeConfig"
                        />
                    </div>
                    <div class="serial__unavailable" v-if="!isAvailable">
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div class="serial__unavailable-text">
                                {{ reasonMsg }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//plugin
import VueBarcode from '@chenfengyuan/vue-barcode'; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import VueQrcode from '@chenfengyuan/vue-qrcode'; // https://github.com/fengyuanchen/vue-qrcode
import VueClipboard from 'vue-clipboard2'
import Util from "@/helper/Utility.js";
import Locale from '@/helper/locale/locale.js';

export default {
    name: 'Serial',
    components: {
        VueBarcode,
        VueQrcode
    },
    props: {
        lbl: Object,
        campaign: Object,
        theme: String,

        busGift: Object,
        modalController: Object
    },
    data: function () {
        return {
            serialHeader: "",
            serial: "",
            serialType: "",
            isLoaded: false,
            isShowCode: true,
            isExpired: false,
            isAvailable: true,
            reasonMsg: '',
            barcodeConfig: {
                height: 100,
                displayValue: false,
                lineColor: '#000000'
            },
            qrcodeConfig: {
                width: 160,
                margin: 0,
            },
            localeCode: Locale.getLocaleCode()
        };
    },
    created: function () {
        VueClipboard.config.autoSetContainer = true;
        Vue.use(VueClipboard);

        this.initial();
    },
    mounted: function () {
        this.busGift.$on('serial-expired', this.serialExpired);
    },
    methods: {
        //event
        changeTab: function (type) {
            this.serialType = type;
            switch (this.serialType) {
                case "CODE_128":
                    this.handleTextHeader(this.lbl.gift_serial.barcode);
                    break;
                case "QR_CODE":
                    this.handleTextHeader(this.lbl.gift_serial.qr_code);
                    break;
                default:
                    this.handleTextHeader(this.lbl.gift_serial.code);
                    break;
            }
        },
        //initial
        initial: function () {
            if (!this.campaign.serial) return;

            this.serial = this.campaign.serial;
            this.serialType = 'QR_CODE';
            switch (this.campaign.barcode) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    this.handleTextHeader(this.lbl.gift_serial.barcode);
                    break;
                case 'QR_CODE':
                    this.serialType = 'QR_CODE';
                    this.handleTextHeader(this.lbl.gift_serial.qr_code);
                    break;
                default:
                    this.serialType = 'CODE';
                    this.handleTextHeader(this.lbl.gift_serial.code);
                    break;
            }

            this.initialAvailable();
            this.$nextTick(() => {
                this.isLoaded = true;
            });
        },
        handleTextHeader: function(type) {
            if (this.serialType == 'CODE_128' || this.serialType == 'QR_CODE') {
                var textType = this.localeCode == 1054 ? `${this.lbl.gift_serial.code}${type}` : `${type}`;
                this.serialHeader = Util.stringFormat(this.lbl.gift_serial.show_code_at_shop, textType); 
                return;
            } else {
                this.serialHeader = Util.stringFormat(this.lbl.gift_serial.show_code_at_shop, type);
            }
        },
        initialAvailable: function () {
            if (this.isCancelStatus()) {
                this.isAvailable = false;
                this.reasonMsg = this.lbl.gift_serial.cancel;
                return;
            }

            if (this.serial == 'XXXXXXX') {
                this.isAvailable = false;
                this.reasonMsg = this.lbl.gift_serial.expired;
            }
        },
        //copy clipboard
        onCopyCode: function () {
            if (this.modalController && this.modalController.copySuccessToast) {
                this.modalController.copySuccessToast
                    .clearToast()
                    .setTitle(this.lbl.gift_serial.copy_success_title)
                    .show();
            }
        },
        onErrorCode: function (e) {
            console.log('failed', e);
        },
        isCancelStatus: function () {
            var status = (this.campaign && this.campaign.aiaStatus) ? String(this.campaign.aiaStatus).toLowerCase() : '';
            return status === 'cancel';
        },
        
        //bus
        serialExpired: function () {
            this.isShowCode = false;

            this.serial = 'XXXXXXX';
            this.isExpired = true;
            this.isAvailable = false;
            this.reasonMsg = this.lbl.gift_serial.expired;

            this.$nextTick(() => {
                this.isShowCode = true;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/button.scss";

.serial {
    .serial__tabs {
        display: flex;
        background-color: $color-gray-3;
        border-radius: 8px;
        margin-bottom: 20px;
        overflow: hidden;

        .serial__tab {
            flex: 1;
            padding: 10px 16px;
            cursor: pointer;
            text-align: center;

            &:nth-child(2) {
                border-left: 1px solid $color-white;
                border-right: 1px solid $color-white;
            }

            .serial__tab-label {
                font-size: 14px;
                font-weight: 500;
                color: $color-gray;
            }

            &.serial__tab--active {
                background-color: $color-blue;

                .serial__tab-label {
                    color: $color-white;
                    font-weight: 600;
                }
            }
        }
    }

    .serial__instruction {
        font-size: 14px;
        color: $color-gray;
        text-align: center;
        margin-bottom: 20px;
    }

    .serial__code-wrapper {
        position: relative;
        padding: 10px 10px 0;

        .serial__code {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 160px;
            margin: {
                top: 25px;
                bottom: 25px;
            }

            &--text {
                .serial__code-value {
                    font-family: var(--font-family-thai), sans-serif;
                    font-size: 32px;
                    font-weight: 500;
                    color: $color-gray;
                    text-align: center;
                    margin: 20px 0 0 0;
                    line-height: 1.2;
                    word-break: break-word;

                    &.serial__code-value--long {
                        font-size: 32px;
                        letter-spacing: 1px;
                    }

                    &.serial__code-value--expired {
                        color: #a5a5a5;
                    }
                }

                .serial__copy-button {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 6px 10px;
                    background-color: $color-white;
                    border: 1.5px solid $color-red;
                    border-radius: 8px;
                    cursor: pointer;
                    margin-top: 8px;

                    .serial__copy-icon {
                        flex-shrink: 0;
                    }

                    .serial__copy-text {
                        font-size: 14px;
                        font-weight: 600;
                        color: $color-red;
                        display: flex;
                        flex-wrap: nowrap;
                    }
                }
            }

            &--barcode {
                .serial__barcode {
                    width: fit-content;
                    flex: 0 0 fit-content;
                    margin: auto;
                    max-width: 100%;

                    .serial__barcode-image {
                        max-width: 100%;
                    }
                }
            }

            &--qrcode {
                .serial__qrcode {
                    width: 160px;
                    flex: 0 0 160px;
                    margin: {
                        left: auto;
                        right: auto;
                    }
                }
            }
        }

        .serial__unavailable {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            .serial__unavailable-wrapper {
                position: relative;
                width: 100%;
                height: 100%;

                .serial__unavailable-text {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    right: 0;
                    padding: {
                        top: 20px;
                        bottom: 25px;
                    }
                    transform: translateY(-50%);
                    color: $color-gray-4;
                    font-size: 32px;
                    font-weight: 500;
                    text-align: center;

                    &.serial__unavailable-text--min-privilege {
                        font-size: 32px;
                        font-weight: 500;
                        text-align: center;
                    }
                }

                &.serial__unavailable-wrapper--mass {
                    background-color: $color-white;
                }

                &.serial__unavailable-wrapper--prestige {
                    background-color: $color-white;
                }
            }
        }
    }
}
</style>
